export default __webpack_public_path__ + "static/media/reptile.e0d559de.svg";